import { Injectable } from '@angular/core';
import {Http, Response} from "@angular/http";

import {UtilService} from "../util";
import {Observable} from "rxjs/Observable";
import {System} from "../../models/system.model";

@Injectable()
export class SystemService {

  constructor(private http: Http, private utilService: UtilService) { }

  getSystemById(id: string): Observable<System> {
    const url = `/core/systems/${id}`;

    return this.http.get(url)
      .map((res: Response) => {
        return this.utilService.outputParser(res)
      })
      .catch(this.utilService.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/system/system.service.ts